import { takeLatest, put, call } from 'redux-saga/effects';

import { getLancamentos } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA,
  NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_PENDING,
  NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
  NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_VENDA_PRODUCAO_AGRICOLA } from '@commons/consts';

function* sagaNewFilterNextPageVendaProducaoAgricola(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_VENDA_PRODUCAO_AGRICOLA) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_VENDA_PRODUCAO_AGRICOLA)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    let list = yield call(getLancamentos, idFazenda, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);

    sessionStorage.setItem(CONST_FILTER_VENDA_PRODUCAO_AGRICOLA, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {

    yield put({ type: NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_FAILURE })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPageVendaProducaoAgricola() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA, sagaNewFilterNextPageVendaProducaoAgricola)
}